import {
  CountAdminsRequest,
  CountAdminsResponse,
  SchoolAdminOnboardingCheckRequest,
  OrgRefScope
} from "../../../../types/gqlTypes/graphql"
import { executeQuerySideload } from "../../helpers/studyPlan"
import { apolloCubeClient } from "../../helpers/studyPlan/studyPlanApolloStatic"
import {
  CHECK_ONBOARDING_QUERY,
  GET_SCHOOL_ADMIN,
  GET_SCHOOL_ADMINS_COUNT_QUERY
} from "./orgSchoolAdminQueries"

export async function getSchoolAdmin(id: string, orgRefScope: OrgRefScope) {
  const { data } = await apolloCubeClient.query({
    query: GET_SCHOOL_ADMIN,
    variables: { id, orgRefScope },
    fetchPolicy: "network-only" // Always fetch fresh data
  })

  return data?.schoolAdmin?.get || null
}

export async function schoolAdminCheckOnboarding(
  data: SchoolAdminOnboardingCheckRequest
): Promise<boolean> {
  const response = await executeQuerySideload(CHECK_ONBOARDING_QUERY, { data })
  return response.schoolAdmin.checkOnboarding.shouldShowOnboarding
}

export const getSchoolAdminsCount = async (
  data: CountAdminsRequest
): Promise<CountAdminsResponse> => {
  const response = await executeQuerySideload(GET_SCHOOL_ADMINS_COUNT_QUERY, {
    data
  })

  return response?.schoolAdmin.count
}
